import type { ConfiguredAddOn, ConfiguredService } from '@/features/service-plans';
import { isIndependentLink } from '@features/service-plans/utils/linkedAddOns';
import { toDateKey, type DateKey } from './dateKey';

export interface DueBasketItem {
    grossPrice: number; // major units
    dueDate: DateKey | null;
}

const indexServiceDates = (services: ConfiguredService[]): Map<string, string> => {
    const dates = new Map<string, string>();
    for (const service of services) {
        if (!dates.has(service.instanceId) && service.startDate) {
            dates.set(service.instanceId, service.startDate);
        }
    }
    return dates;
};

/** An add-on is due on its own date, else on its linked service's date; otherwise undated. */
export const effectiveAddOnDueDate = (
    addOn: ConfiguredAddOn,
    serviceDates: ReadonlyMap<string, string>,
): DateKey | null => {
    const ownDate = toDateKey(addOn.startDate);
    if (ownDate !== null || isIndependentLink(addOn.linkedServiceId)) {
        return ownDate;
    }
    return toDateKey(serviceDates.get(addOn.linkedServiceId));
};

export const toDueBasketItems = (
    services: ConfiguredService[],
    addOns: ConfiguredAddOn[],
): DueBasketItem[] => {
    const serviceDates = indexServiceDates(services);
    return [
        ...services.map((service) => ({ grossPrice: service.gross_price, dueDate: toDateKey(service.startDate) })),
        ...addOns.map((addOn) => ({ grossPrice: addOn.gross_price, dueDate: effectiveAddOnDueDate(addOn, serviceDates) })),
    ];
};
